import React from 'react';
import { NavLink } from 'react-router-dom';
import { BarChart3Icon, ClockIcon, FolderIcon, HomeIcon, ListIcon, SettingsIcon, SparklesIcon } from 'lucide-react';
import { currentUser } from '../data/mockData';
type NavItem = {
  label: string;
  to: string;
  icon: React.ElementType;
  badge?: {
    value: number;
    tone: 'neutral' | 'danger';
  };
};
const workspaceNav: NavItem[] = [{
  label: 'Overview',
  to: '/',
  icon: HomeIcon
}, {
  label: 'Leads',
  to: '/leads',
  icon: ListIcon,
  badge: {
    value: 38,
    tone: 'neutral'
  }
}, {
  label: 'Loans',
  to: '/loans',
  icon: FolderIcon,
  badge: {
    value: 5,
    tone: 'neutral'
  }
}, {
  label: 'Follow-ups',
  to: '/follow-ups',
  icon: ClockIcon,
  badge: {
    value: 7,
    tone: 'danger'
  }
}, {
  label: 'Reports',
  to: '/reports',
  icon: BarChart3Icon
}];
const comingSoon = [{
  label: 'Automations',
  icon: SparklesIcon
}, {
  label: 'Admin',
  icon: SettingsIcon
}];
export function Sidebar() {
  return <aside className="hidden w-[196px] shrink-0 flex-col justify-between bg-sidebar text-white md:flex" data-id="element-192" data-mp="1lz5ddi8jjyhs">
      <div data-id="element-193" data-mp="1qqngocy1eb5x">
        <div className="px-3 py-4" data-id="element-194" data-mp="1qrfb3kfwe2um">
          <div className="rounded-sm border border-white/25 px-2.5 py-1.5 text-center" data-id="element-195" data-mp="1qsgnptckaxeg">
            <div className="font-display text-[11.5px] font-bold uppercase leading-tight text-brand" data-id="element-196" data-mp="1d0ts7vqg1swq">
              United Mortgage
            </div>
            <div className="text-[8.5px] font-medium uppercase tracking-[0.32em] text-white/70" data-id="element-197" data-mp="24pn6hnxacw3o">
              Lending
            </div>
          </div>
          <p className="mt-2 text-center text-[9.5px] uppercase tracking-widest text-white/35" data-id="element-198" data-mp="29ogi1at0id17">
            Loan Officer Workspace
          </p>
        </div>

        <nav className="mt-6 px-2" aria-label="Workspace" data-id="element-199" data-mp="20ns4sibg0gpd">
          <p className="px-2 pb-2 text-[10px] font-semibold uppercase tracking-widest text-white/35" data-id="element-200" data-mp="20qe8u7z4ke2u">
            Workspace
          </p>
          <ul className="space-y-0.5" data-id="element-201" data-mp="p9oatc4uuskb">
            {workspaceNav.map(item => <li key={item.label} data-id="element-202" data-mp="2qz3o74234xfp">
                <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => ['flex items-center gap-2.5 rounded-md px-2.5 py-2 text-[13px] font-medium transition-colors', isActive ? 'bg-sidebar-active text-white' : 'text-white/65 hover:bg-sidebar-hover hover:text-white'].join(' ')} data-id="element-203" data-mp="2qy2bkv5f82vv">
                  <item.icon className="h-4 w-4" aria-hidden="true" data-id="element-204" data-mp="23b2lwcvi2d8q" />
                  <span className="flex-1" data-id="element-205" data-mp="1yaocaqe92v8l">{item.label}</span>
                  {item.badge && <span className={['rounded px-1.5 py-0.5 text-[10px] font-semibold', item.badge.tone === 'danger' ? 'bg-danger text-white' : 'bg-white/10 text-white/70'].join(' ')} data-id="element-206" data-mp="1u9mjaraxfff2">
                      {item.badge.value}
                    </span>}
                </NavLink>
              </li>)}
          </ul>
        </nav>

        <div className="mt-7 px-2" data-id="element-207" data-mp="1k6h963agdg50">
          <p className="px-2 pb-2 text-[10px] font-semibold uppercase tracking-widest text-white/35" data-id="element-208" data-mp="1o6hn7mtn3pbj">
            Coming soon
          </p>
          <ul className="space-y-0.5" data-id="element-209" data-mp="rha0ibhaba61">
            {comingSoon.map(item => <li key={item.label} className="flex cursor-not-allowed items-center gap-2.5 rounded-md px-2.5 py-2 text-[13px] font-medium text-white/25" aria-disabled="true" data-id="element-210" data-mp="wftm2aryujxv">
                <item.icon className="h-4 w-4" aria-hidden="true" data-id="element-211" data-mp="15ddrzx0rx4et" />
                {item.label}
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 px-3 py-3" data-id="element-212" data-mp="2gtc4ybz2oalb">
        <div className="flex items-center gap-2.5" data-id="element-213" data-mp="2fd8254s2l6ly">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand text-[11px] font-semibold" data-id="element-214" data-mp="2fdzxcehr92bp">
            {currentUser.initials}
          </div>
          <div className="min-w-0 leading-tight" data-id="element-215" data-mp="2oeelrmq0mxjf">
            <div className="truncate text-[13px] font-semibold" data-id="element-216" data-mp="2oc1yqv5ehwzi">
              {currentUser.name}
            </div>
            <div className="truncate text-[10px] text-white/45" data-id="element-217" data-mp="2ycca0a7vkuc1">
              {currentUser.org}
            </div>
          </div>
          <span className="ml-auto h-2 w-2 rounded-full bg-emerald-400" aria-label="Online" data-id="element-218" data-mp="2te0zrydo4hta" />
        </div>
      </div>
    </aside>;
}